import { EQueueConfigType } from "src/Types/ReDoc/EQueue";
import { PAUSE_START_KEY } from "src/Slicers/eQueue/ReturnSlicer";

const PAUSE_TOTAL_PREFIX = "return_pause_total";

export const formatElapsedSeconds = (diffSec: number): string => {
	const safe = Math.max(0, diffSec);
	const pad = (n: number) => String(n).padStart(2, "0");
	const h = Math.floor(safe / 3600);
	const m = Math.floor((safe % 3600) / 60);
	const s = safe % 60;
	return h > 0 ? `${h}:${pad(m)}:${pad(s)}` : `${pad(m)}:${pad(s)}`;
};

export const getPauseTotalStorageKey = (config: EQueueConfigType): string | undefined => {
	if (!config.pultId || config.officeId < 0) {
		return undefined;
	}
	return `${PAUSE_TOTAL_PREFIX}_${config.officeId}_${config.pultId}`;
};

export const getPauseTotalSeconds = (storageKey?: string): number => {
	if (!storageKey) {
		return 0;
	}
	const raw = localStorage.getItem(storageKey);
	const parsed = Number(raw);
	return Number.isFinite(parsed) && parsed > 0 ? Math.floor(parsed) : 0;
};

export const addPauseTotalSeconds = (storageKey: string | undefined, seconds: number): void => {
	if (!storageKey || seconds <= 0) {
		return;
	}
	const next = getPauseTotalSeconds(storageKey) + Math.floor(seconds);
	localStorage.setItem(storageKey, String(next));
};

export const clearPauseTotalSeconds = (storageKey?: string): void => {
	if (!storageKey) {
		return;
	}
	localStorage.removeItem(storageKey);
};

/** Добавляет длительность текущего перерыва в суммарное время окна. */
export const commitPauseSession = (storageKey?: string): void => {
	const start = localStorage.getItem(PAUSE_START_KEY);
	if (!start || !storageKey) {
		return;
	}
	const seconds = Math.floor((Date.now() - new Date(start).getTime()) / 1000);
	addPauseTotalSeconds(storageKey, seconds);
};
